<div fxLayout="column">
  <!-- IE requires all fxLayout="column" elements to have the child contents wrapped in a plain div tag -->
  <div *ngIf="isBrowserIE; else notePaymentHistoryDetailsListFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
    <ng-container *ngTemplateOutlet="notePaymentHistoryDetailsListFlexColumnTemplate"></ng-container>
  </div>
</div>

<ng-template #notePaymentHistoryDetailsListFlexColumnTemplate>
  <div fxLayout="column">
    <div class="display-text normal-paragraph-spacing" style="text-align: center" *ngIf="showSpinner">
      <mat-spinner color="accent" diameter="32"></mat-spinner>
    </div>
    <div fxLayout="column" *ngIf="!showSpinner">
      <div *ngIf="isBrowserIE; else notePaymentHistoryDetailsListTableFlexColumnTemplate" [ngClass]="{ 'ie-display': isBrowserIE }">
        <ng-container *ngTemplateOutlet="notePaymentHistoryDetailsListTableFlexColumnTemplate"></ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #notePaymentHistoryDetailsListTableFlexColumnTemplate>
  <div fxFlex="100%" class="display-text primary-dark-color-important">
    <b><span i18n="@@note-payment-history-details-list.table.title">note-payment-history-details-list.table.title</span></b>
  </div>

  <div fxFlex="100%" class="display-text title-spacer" *ngIf="!notePaymentHistoryDetailsListFound">
    <i><span i18n="@@note-payment-history-details-list.table.no-records">note-payment-history-details-list.table.no-records</span></i>
  </div>

  <div fxFlex="100%" [ngStyle]="{ display: tableDisplayStyle }">
    <mat-table #table [dataSource]="tableDataSource" class="primary-lightest-bg scrollable-list" ngClass.lt-md="small-table-text">
      <!-- paymentDate Column -->
      <ng-container matColumnDef="paymentDate">
        <mat-header-cell *matHeaderCellDef fxFlex="14%">
          <span
            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
            i18n="@@note-payment-history-details-list.table.column-header.payment-date"
            >note-payment-history-details-list.table.column-header.payment-date</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="14%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.paymentDate | date: 'MM/dd/yyyy'
        }}</mat-cell>
      </ng-container>
      <!-- paymentId Column -->
      <ng-container matColumnDef="paymentId">
        <mat-header-cell *matHeaderCellDef fxFlex="14%">
          <span
            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
            i18n="@@note-payment-history-details-list.table.column-header.payment-id"
            >note-payment-history-details-list.table.column-header.payment-id</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="14%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.paymentId
        }}</mat-cell>
      </ng-container>
      <!-- paymentAmount Column -->
      <ng-container matColumnDef="paymentAmount">
        <mat-header-cell *matHeaderCellDef fxFlex="14%">
          <span
            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
            i18n="@@note-payment-history-details-list.table.column-header.payment-amount"
            >note-payment-history-details-list.table.column-header.payment-amount</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="14%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.paymentAmount | currency
        }}</mat-cell>
      </ng-container>
      <!-- principalAmountApplied Column -->
      <ng-container matColumnDef="principalAmountApplied">
        <mat-header-cell *matHeaderCellDef fxFlex="14%">
          <span
            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
            i18n="@@note-payment-history-details-list.table.column-header.principal-amount-applied"
            >note-payment-history-details-list.table.column-header.principal-amount-applied</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="14%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.principalAmountApplied | currency
        }}</mat-cell>
      </ng-container>
      <!-- interestAmountApplied Column -->
      <ng-container matColumnDef="interestAmountApplied">
        <mat-header-cell *matHeaderCellDef fxFlex="14%">
          <span
            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
            i18n="@@note-payment-history-details-list.table.column-header.interest-amount-applied"
            >note-payment-history-details-list.table.column-header.interest-amount-applied</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="14%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.interestAmountApplied | currency
        }}</mat-cell>
      </ng-container>
      <!-- feeAmount Column -->
      <ng-container matColumnDef="feeAmount">
        <mat-header-cell *matHeaderCellDef fxFlex="14%">
          <span
            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
            i18n="@@note-payment-history-details-list.table.column-header.fee-amount"
            >note-payment-history-details-list.table.column-header.fee-amount</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="14%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.feeAmount | currency
        }}</mat-cell>
      </ng-container>
      <!-- paymentType Column -->
      <ng-container matColumnDef="paymentType">
        <mat-header-cell *matHeaderCellDef fxFlex="16%">
          <span
            [ngClass]="{ 'mat-column-header-ie': isBrowserIE }"
            i18n="@@note-payment-history-details-list.table.column-header.payment-type"
            >note-payment-history-details-list.table.column-header.payment-type</span
          >
        </mat-header-cell>
        <mat-cell *matCellDef="let row" fxFlex="16%" ngClass.lt-md="small-table-text" [ngClass]="{ 'mat-column-data-ie': isBrowserIE }">{{
          row.paymentType
        }}</mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="tableDisplayedColumns" ngClass.lt-md="small-header-row"></mat-header-row>
      <mat-row *matRowDef="let row; columns: tableDisplayedColumns" ngClass.lt-md="small-row"></mat-row>
    </mat-table>
  </div>
  <div fxFlex="100%" fxLayoutAlign="end center" class="small-display-text primary-light-color" *ngIf="notePaymentHistoryDetailsListFound">
    <app-table-record-count
      [recordCount]="notePaymentHistoryDetailsList.length"
      i18n-singularLabel="@@note-payment-history-details-list.table.record-count.singular-label"
      singularLabel="note-payment-history-details-list.table.record-count.singular-label"
      i18n-multipleLabel="@@note-payment-history-details-list.table.record-count.multiple-label"
      multipleLabel="note-payment-history-details-list.table.record-count.multiple-label"
    ></app-table-record-count>
  </div>
</ng-template>
